import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  homeworkColors,
  homeworkPulseColors,
  isMissedEvent,
  HOMEWORK_DONE_COLOR,
} from '../constants';
import { rememberHomeworkEvent } from '../homework-handoff';
import sprite from '../../../img/sprites.svg';
import './schedule-event.scss';

/**
 * Напрям без рядка в `images` дає URL виду `.../32x21.` — браузер малює значок «бите зображення».
 * Ховаємо картинку, але лишаємо її місце, щоб рядки в клітинці не роз'їхались.
 */
const hideBrokenFlag = (e) => e.currentTarget.classList.add('is-broken');

const ScheduleEvent = ({ event, compact }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const typeKey = event.type_key || 'lesson';
  const typeLabel = event.type_label || '';

  // Прод-правило: пульсує все, крім виконаного ДЗ (homework_icon_color === 4).
  const shouldPulse = event.homework_icon_color !== HOMEWORK_DONE_COLOR;
  const pulseStyle = shouldPulse
    ? { '--pulse-color': homeworkPulseColors[event.homework_icon_color] }
    : {};

  const openHomework = (e) => {
    e.stopPropagation();
    rememberHomeworkEvent(event);
    navigate('/homework', { state: { from: location.pathname } });
  };

  return (
    <div
      className={`schedule-event schedule-event--${typeKey} ${compact ? 'schedule-event--compact' : ''} ${isMissedEvent(event) ? 'is-missed' : ''}`}
      title={`${typeLabel} · ${event.direction_short_name || ''}`}
    >
      {!compact && <span className="schedule-event__type">{typeLabel}</span>}

      <img
        src={event.image}
        alt=''
        className="schedule-event__flag"
        onError={hideBrokenFlag}
      />
      <span className="schedule-event__time">{event.hour}:00</span>

      {event.is_show_homework ? (
        <span className="schedule-event__hw">
          {event.is_show_icon_new && <span className="new-badge--sm">new</span>}
          <button
            type="button"
            className="schedule-event__hw-btn"
            onClick={openHomework}
            aria-label="Домашнє завдання"
          >
            <svg
              className={`icon icon--sm icon--${homeworkColors[event.homework_icon_color]} ${shouldPulse ? 'pulsing-icon-small' : ''}`}
              style={pulseStyle}
            >
              <use href={`${sprite}#book`}></use>
            </svg>
          </button>
        </span>
      ) : (
        <span className="schedule-event__hw schedule-event__hw--empty" />
      )}
    </div>
  );
};

ScheduleEvent.propTypes = {
  event: PropTypes.object.isRequired,
  // true, коли тип уже написаний у стрічці з числом — подія лишається в один рядок.
  compact: PropTypes.bool,
};

ScheduleEvent.defaultProps = {
  compact: false,
};

export default ScheduleEvent;
